export default __webpack_public_path__ + "static/media/1884.04491107.png";